import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Employee } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class EmployeeModule extends VuexModule {
    @Action
    [Employee.getEmployeeList]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/employees/list`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Employee.findPageEmployee](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/employees`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Employee.saveEmployee](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/employees/save`, values, { headers: { 'Content-Type': 'multipart/form-data' }})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

        @Action
    [Employee.deleteEmployee](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/employees/delete`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Employee.selectByUserName]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/employees/selectByUserName`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
    
    @Action
    [Employee.updateStatus](params) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/employees/updateStatus`, params)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Employee.getQueueNumber]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/queue-number/assignNumberForTeller`, {})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Employee.callSpeaker](params) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/queue-number/callSpeaker`, params)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Employee.findByDeviceId](params) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/employees/findByDeviceId`, params)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

}